export var TipoRequerenteEnum;
(function (TipoRequerenteEnum) {
    TipoRequerenteEnum["NAO_TEM"] = "NAO_TEM";
    TipoRequerenteEnum["PESSOA_FISICA"] = "PESSOA_FISICA";
    TipoRequerenteEnum["PESSOA_JURIDICA"] = "PESSOA_JURIDICA";
    TipoRequerenteEnum["GOVERNO"] = "GOVERNO";
})(TipoRequerenteEnum || (TipoRequerenteEnum = {}));
